import { defineMessages } from 'react-intl';
const messages = defineMessages({
    RemindersOverview: { id: 'RemindersOverview', defaultMessage: 'Reminders' },
    ReminderSettings: { id: 'ReminderSettings', defaultMessage: 'Reminder settings' },
    OpenInvoices: { id: 'OpenInvoices', defaultMessage: 'Open invoices' },
    OverdueUpTo30Days: { id: 'OverdueUpTo30Days', defaultMessage: 'Overdue 0-30 days' },
    OverdueMoreThan30Days: { id: 'OverdueMoreThan30Days', defaultMessage: 'Overdue > 30 days' },
    OverdueWithoutReminder: {
        id: 'OverdueWithoutReminder',
        defaultMessage: 'Overdue, no reminder yet',
    },
    RemindersSent: { id: 'InvoicesReminded', defaultMessage: 'Invoices reminded' },
    RemindersSentTodayAndWeek: {
        id: 'RemindersSentTodayAndWeek',
        defaultMessage: '{today} today · {week} past 7 days',
    },
    DeliveryFailedReminders: {
        id: 'DeliveryFailedReminders',
        defaultMessage: 'Delivery failed',
    },
    RemindersPaused: { id: 'RemindersPaused', defaultMessage: 'Automatic reminders paused' },
    InvoiceCount: {
        id: 'InvoiceCount',
        defaultMessage: '{count, plural, one {{formatted} invoice} other {{formatted} invoices}}',
    },
    OpenAmountByAge: { id: 'OpenAmountByAge', defaultMessage: 'Open amount by age' },
    AgeNotDue: { id: 'AgeNotDue', defaultMessage: 'Not yet due' },
    Age1To30: { id: 'Age1To30', defaultMessage: '0-30 days' },
    Age31To60: { id: 'Age31To60', defaultMessage: '31-60 days' },
    Age61To90: { id: 'Age61To90', defaultMessage: '61-90 days' },
    Age90Plus: { id: 'Age90Plus', defaultMessage: '> 90 days' },
    OverdueInvoicesTab: { id: 'OverdueInvoicesTab', defaultMessage: 'Overdue invoices' },
    SentRemindersTab: { id: 'SentRemindersTab', defaultMessage: 'Sent reminders' },
    UpcomingRemindersTab: { id: 'UpcomingRemindersTab', defaultMessage: 'Upcoming reminders' },
    CustomersTab: { id: 'PaymentBehaviourTab', defaultMessage: 'Payment behaviour' },
    Customer: { id: 'Customer', defaultMessage: 'Customer' },
    AvgDaysLate: { id: 'AvgDaysLate', defaultMessage: 'Avg. days late' },
    PaidLate: { id: 'PaidLate', defaultMessage: 'Paid late' },
    PaidLateOf: { id: 'PaidLateOf', defaultMessage: '{late} of {total}' },
    RemindersLastMonths: { id: 'RemindersLastMonths', defaultMessage: 'Reminders ({months} m)' },
    RemindersPerInvoice: { id: 'RemindersPerInvoice', defaultMessage: 'Per invoice' },
    OverdueOfOpen: { id: 'OverdueOfOpen', defaultMessage: '{overdue} overdue' },
    NoCustomersMatchFilters: {
        id: 'NoCustomersMatchFilters',
        defaultMessage: 'No customers with at least {min} paid invoices in the last {months} months match the filters.',
    },
    PaidInvoicesWindow: { id: 'PaidInvoicesWindow', defaultMessage: 'Paid invoices of the last' },
    Months: { id: 'PaidInvoicesWindowMonths', defaultMessage: 'months' },
    MinPaidInvoices: { id: 'MinPaidInvoices', defaultMessage: 'Min. paid invoices' },
    MinAvgDaysLate: { id: 'MinAvgDaysLate', defaultMessage: 'Min. avg. days late' },
    PaidOnTime: { id: 'PaidOnTime', defaultMessage: 'pays on time' },
    OpenCustomer: { id: 'OpenCustomer', defaultMessage: 'Open customer' },
    AutosendOff: { id: 'AutosendOff', defaultMessage: 'Automatic reminders off for this customer' },
    OwnCompanies: { id: 'OwnCompanies', defaultMessage: 'Own companies' },
    ReminderStatusAll: { id: 'ReminderStatusAll', defaultMessage: 'All open invoices' },
    ReminderStatusNone: { id: 'ReminderStatusNone', defaultMessage: 'No reminder sent yet' },
    ReminderStatusReminded: { id: 'ReminderStatusReminded', defaultMessage: 'Reminder sent' },
    ReminderStatusFailed: {
        id: 'ReminderStatusFailed',
        defaultMessage: 'Last reminder not delivered',
    },
    ReminderStatusPaused: {
        id: 'ReminderStatusPaused',
        defaultMessage: 'Automatic reminders paused',
    },
    InvoiceNumber: { id: 'InvoiceNumber', defaultMessage: 'Invoice number' },
    GroupPerCustomer: { id: 'GroupPerCustomer', defaultMessage: 'Group per customer' },
    ResetFilters: { id: 'ResetFilters', defaultMessage: 'Reset filters' },
    Relation: { id: 'Relation', defaultMessage: 'Relation' },
    Invoice: { id: 'Invoice', defaultMessage: 'Invoice' },
    Invoices: { id: 'Invoices', defaultMessage: 'Invoices' },
    OwnCompany: { id: 'OwnCompany', defaultMessage: 'Own company' },
    InvoiceDate: { id: 'InvoiceDate', defaultMessage: 'Invoice date' },
    Expires: { id: 'Expires', defaultMessage: 'Due date' },
    DaysOverdue: { id: 'DaysOverdue', defaultMessage: 'Days overdue' },
    OpenAmount: { id: 'OpenAmount', defaultMessage: 'Open amount' },
    PartiallyPaid: { id: 'PartiallyPaid', defaultMessage: 'Partially paid' },
    PartiallyPaidTitle: { id: 'PartiallyPaidTitle', defaultMessage: '{paid} of {total} paid' },
    OldestOverdue: { id: 'OldestOverdue', defaultMessage: 'Oldest overdue' },
    Reminders: { id: 'Reminders', defaultMessage: 'Reminders' },
    LastReminder: { id: 'LastReminder', defaultMessage: 'Last reminder' },
    NextReminder: { id: 'NextReminder', defaultMessage: 'Next reminder' },
    Automatic: { id: 'Automatic', defaultMessage: 'Automatic' },
    Manual: { id: 'Manual', defaultMessage: 'Manual' },
    ManualBy: { id: 'ManualBy', defaultMessage: 'Manual · {user}' },
    NightlyRun: { id: 'NightlyRun', defaultMessage: 'Nightly run' },
    AutosendOn: { id: 'AutosendOn', defaultMessage: 'Automatic reminders on' },
    AutosendOffRelation: {
        id: 'AutosendOffRelation',
        defaultMessage: 'Automatic reminders off for this relation',
    },
    AutosendOffStream: {
        id: 'AutosendOffStream',
        defaultMessage: 'Automatic reminders off for this assignment',
    },
    AutosendOffCompany: {
        id: 'AutosendOffCompany',
        defaultMessage: 'Automatic reminders off for this own company',
    },
    BillingError: {
        id: 'BillingError',
        defaultMessage: 'Billing error: the nightly run skips this invoice',
    },
    NoAutomaticReminderPlanned: {
        id: 'NoAutomaticReminderPlanned',
        defaultMessage: 'No automatic reminder planned',
    },
    DaysShort: { id: 'DaysShort', defaultMessage: '{days} d' },
    DueInDays: { id: 'DueInDays', defaultMessage: 'due in {days} d' },
    SendReminder: { id: 'SendReminder', defaultMessage: 'Send reminder' },
    SendGroupedReminder: { id: 'SendGroupedReminder', defaultMessage: 'Send grouped reminder' },
    SendReminderToSelected: {
        id: 'SendReminderToSelected',
        defaultMessage: 'Send reminder for {count} selected',
    },
    EmailHistory: { id: 'EmailHistory', defaultMessage: 'Email history' },
    RegisterPayment: { id: 'RegisterPayment', defaultMessage: 'Register payment' },
    OpenInvoice: { id: 'OpenInvoice', defaultMessage: 'Open in billing overview' },
    NoInvoicesMatchFilters: {
        id: 'NoInvoicesMatchFilters',
        defaultMessage: 'No open invoices match the current filters.',
    },
    NoRemindersMatchFilters: {
        id: 'NoRemindersMatchFilters',
        defaultMessage: 'No reminders match the current filters.',
    },
    SentOn: { id: 'SentOn', defaultMessage: 'Sent on' },
    RuleOrTemplate: { id: 'RuleOrTemplate', defaultMessage: 'Rule / template' },
    Status: { id: 'Status', defaultMessage: 'Status' },
    Rule: { id: 'Rule', defaultMessage: 'Rule' },
    AllRules: { id: 'AllRules', defaultMessage: 'All rules' },
    AllStatuses: { id: 'AllStatuses', defaultMessage: 'All statuses' },
    AllSources: { id: 'AllSources', defaultMessage: 'Automatic and manual' },
    GroupedMail: {
        id: 'GroupedMail',
        defaultMessage: 'One mail for {count} invoices',
    },
    PerRule: { id: 'PerRule', defaultMessage: 'Per rule (last 30 days)' },
    Sent: { id: 'Sent', defaultMessage: 'Sent' },
    Failed: { id: 'Failed', defaultMessage: 'Failed' },
    UpcomingNothingThatDay: { id: 'UpcomingNothingThatDay', defaultMessage: 'No reminders' },
    UpcomingDaySentence: {
        id: 'UpcomingDaySentence',
        defaultMessage: '{mails, plural, one {{mailsFormatted} mail} other {{mailsFormatted} mails}} to {customers, plural, one {{customersFormatted} customer} other {{customersFormatted} customers}} for {invoices, plural, one {{invoicesFormatted} invoice} other {{invoicesFormatted} invoices}}, {amount} open',
    },
    UpcomingGroupedMail: {
        id: 'UpcomingGroupedMail',
        defaultMessage: '{template} · one mail for {count} invoices',
    },
    UpcomingInvoiceDetail: {
        id: 'UpcomingInvoiceDetail',
        defaultMessage: 'due {due}, {days} days overdue that day',
    },
    Tomorrow: { id: 'Tomorrow', defaultMessage: 'Tomorrow' },
    ShowInvoices: { id: 'ShowInvoices', defaultMessage: 'Show invoices' },
    HideInvoices: { id: 'HideInvoices', defaultMessage: 'Hide invoices' },
    InvoicesRemindedPerDay: {
        id: 'InvoicesRemindedPerDay',
        defaultMessage: 'Invoices reminded per day (last 14 days)',
    },
    PartOfGroupedMail: {
        id: 'PartOfGroupedMail',
        defaultMessage: 'One mail, {count} invoices',
    },
    PaidOn: { id: 'PaidOn', defaultMessage: 'Paid {date}' },
    PaidSinceReminder: { id: 'PaidSinceReminder', defaultMessage: 'Paid after this reminder' },
    OpenAmountNow: { id: 'OpenAmountNow', defaultMessage: 'Open amount' },
    TabDetailOverdue: {
        id: 'TabDetailOverdue',
        defaultMessage: '{count, plural, =0 {all reminded} other {{formatted} without reminder}}',
    },
    TabDetailSent: { id: 'TabDetailSent', defaultMessage: '{today} today' },
    TabDetailUpcoming: {
        id: 'TabDetailUpcoming',
        defaultMessage: 'next on {date}: {count, plural, one {{formatted} reminder} other {{formatted} reminders}}',
    },
    NothingUpcomingShort: { id: 'NothingUpcomingShort', defaultMessage: 'nothing planned' },
});
export default messages;
